import type { ReactNode } from 'react';
import { Card, Space, Tag, Typography } from 'antd';
import { PHASE_STATUS_META, type PhaseStatus } from './RegistryPhaseWorkspace';

const { Title, Paragraph, Text } = Typography;

/** Cip de statistică (număr + etichetă); invizibil la 0. */
export function StatChip({ count, label }: { count: number; label: string }) {
  if (!count) return null;
  return <Tag data-testid="stat-chip">{`${count} ${label}`}</Tag>;
}

/** Secțiune dintr-o pagină de fază: card cu iconiță și titlu. */
export function SectionCard({ icon, title, children }: { icon?: ReactNode; title: string; children: ReactNode }) {
  return (
    <Card
      size="small"
      style={{ marginBottom: 16 }}
      title={
        <Space>
          {icon}
          <Text strong>{title}</Text>
        </Space>
      }
    >
      {children}
    </Card>
  );
}

interface PhaseShellProps {
  /** ex. „Faza 1 — Conștientizare & Anamneză” */
  title: string;
  /** o linie: ce înseamnă faza în parcursul pacientului */
  description: string;
  status: PhaseStatus;
  chips?: ReactNode;
  /** butoanele din dreapta antetului (export PDF etc.) */
  extra?: ReactNode;
  children: ReactNode;
}

/** Cadru comun al unei pagini de fază: antet (titlu + status), descriere, cipuri, secțiuni. */
export default function PhaseShell({ title, description, status, chips, extra, children }: PhaseShellProps) {
  const meta = PHASE_STATUS_META[status];
  return (
    <Card
      title={
        <Space align="center" wrap>
          <Title level={4} style={{ margin: 0 }}>
            {title}
          </Title>
          <Tag color={meta.color} data-testid="phase-status-badge">
            {meta.label}
          </Tag>
        </Space>
      }
      extra={extra}
    >
      <Paragraph type="secondary" style={{ marginTop: 0 }}>
        {description}
      </Paragraph>
      {chips ? <div style={{ marginBottom: 12, display: 'flex', flexWrap: 'wrap', gap: 4 }}>{chips}</div> : null}
      {children}
    </Card>
  );
}
